export enum BootstrapPhase {
    Bootstrap,
    Start
}